export function calculateExtraReferenceVariance(yearTotal: number, extraReferenceYearTotal: number): { variance$: number; variancePct: number } {
    const variance$ = yearTotal - extraReferenceYearTotal;
    const variancePct = extraReferenceYearTotal ? variance$ / Math.abs(extraReferenceYearTotal) : NaN;
    return { variance$, variancePct };
}
